<div class="container">
  <fa-icon class="loader" [icon]="icons.falSpinnerThird" animation="spin"></fa-icon>
  <ng-container [formGroup]="form" #filterContainer>
    <app-area-select
      postcodeLabel="train.postcode"
      streetLabel="train.street"
      [(selectedArea)]="selectedArea"
      (selectedAreaChange)="onSearchArea($event)"
    ></app-area-select>
    <div>
      @for (control of form.controls | keyvalue; track control) {
        <app-atlas-filter-field
          [label]="formLabels[control.key]"
          [value]="control.value.value"
          [choices]="options[control.key]"
          (valueChange)="control.value.setValue($event)"
        ></app-atlas-filter-field>
      }
    </div>
  </ng-container>
</div>
